import { Action } from '@ngrx/store';
import { CustomerProcedureInterface } from '../../models/customer-procedure.interface';

export enum ECustomerProceduresActions {
  GetCustomerProcedures = '[CUSTOMER_PROCEDURES] Get customer procedures',
  GetCustomerProceduresSuccess = '[CUSTOMER_PROCEDURES] Get customer procedures success',
  GetCustomerProceduresFailure = '[CUSTOMER_PROCEDURES] Get customer procedures failure'
}

export class GetCustomerProcedures implements Action {
  public readonly type = ECustomerProceduresActions.GetCustomerProcedures;
  constructor(public procedureType: string, public externalId?: string) {}
}

export class GetCustomerProceduresSuccess implements Action {
  public readonly type = ECustomerProceduresActions.GetCustomerProceduresSuccess;
  constructor(public payload: Array<CustomerProcedureInterface>) {}
}

export class GetCustomerProceduresFailure implements Action {
  public readonly type = ECustomerProceduresActions.GetCustomerProceduresFailure;
}

export type CustomerProceduresActions = GetCustomerProcedures | GetCustomerProceduresSuccess | GetCustomerProceduresFailure;
